import { FC } from 'react';
import withBehaviors, { WithBehaviorsProps } from 'ia-react-core/~/hocs/withBehaviors';
import withShow from 'ia-react-core/~/hocs/withShow';
import compose from '../../../utils/components/#compose';
import withTransclusion from '../../../hocs/transclusion/withTransclusion';
import withSpacing from '../../../hocs/grid/withSpacing';

import Block, { BlockProps } from './Block';

export default compose<FC<WithBehaviorsProps<BlockProps>>>(
  withBehaviors,
  withShow,
  withTransclusion,
  withSpacing,
)(Block);

export * from './Block';
